<template>
	<div>
		<div v-if="!loading" class="profile-container">
			<div style="width: 100%; display: flex; align-items: center; justify-content: center; margin-bottom: 2rem">
				<md-button v-if="edit" class="jb-standard fix" @click="editProfile">Edit Profile</md-button>
			</div>

			<div class="profile-section">
				<div class="profile-row">
					<div class="left">
						<img v-if="profile.profile" class="img" :src="profile.profile" />
						<img v-if="!profile.profile" class="img" :src="cardUserImage" />
					</div>

					<div class="right">
						<h3>{{ `${profile.name} ${profile.surname}` }}</h3>
						<p class="text" style="margin-top: 2rem">{{ profile.bio }}</p>
					</div>
				</div>
			</div>

			<div class="border-container">
				<div class="border">
					<h4 class="title"><md-icon>videocam</md-icon> Introductory Video</h4>
					<div class="video-player">
						<template v-if="profile.introductoryVideoUrl">
							<iframe :src="embeddedVideoUrl" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>
						</template>
						<template v-else>
							<div style="display: flex; flex-direction: column">
								<h3>No Introductory Video Found</h3>
								<br />
								<md-button @click="editProfile" class="jb-standard" style="width: fit-content; margin: auto">Add to Profile</md-button>
							</div>
						</template>
					</div>
				</div>
			</div>

			<div class="border-container" v-if="!loading && profile.qualifications && profile.qualifications.length > 0">
				<h4 class="title"><md-icon>school</md-icon> Education</h4>
				<div class="">
					<div v-for="(qualification, index) in profile.qualifications" :key="index" class="qualification-card">
						<div class="row">
							<h3 class="card-title">{{ qualification.institution }}</h3>
							<p class="date">
								{{ qualification.startDate }}
								-
								{{ qualification.endDate && qualification.endDate !== 'Invalid date' ? qualification.endDate : 'Present' }}
							</p>
						</div>
						<p class="text">{{ qualification.degree }}</p>
						<div class="row pill">
							<p class="tag-pill qualification">{{ qualification.year }}</p>
						</div>
					</div>
				</div>
			</div>

			<div class="border-container" v-if="!loading && profile.experience && profile.experience.length > 0">
				<h4 class="title"><md-icon>work</md-icon> Experience</h4>
				<div class="">
					<div v-for="(experience, index) in profile.experience" :key="index" class="qualification-card">
						<div class="row">
							<h3 class="card-title">{{ experience.jobTitle }}</h3>
							<p class="date">
								{{ experience.startDate }}
								-
								{{ experience.endDate && experience.endDate !== 'Invalid date' ? experience.endDate : 'Present' }}
							</p>
						</div>
						<p class="text">{{ experience.employer }}</p>
						<p class="text">{{ experience.description }}</p>
					</div>
				</div>
			</div>
			<div class="border-container" v-else>
				<h4 class="title"><md-icon>work</md-icon> Experience</h4>
				<div class="">
					<div style="display: flex; flex-direction: column">
						<h3 class="not-found">You currently have no experience added on your profile</h3>
						<br />
						<md-button @click="editProfile" class="jb-standard" style="width: fit-content; margin: auto">Add to Profile</md-button>
					</div>
				</div>
			</div>

			<div class="border-container" v-if="passedSkills.length > 0">
				<h4 class="title"><md-icon>build</md-icon> Skills</h4>
				<div>
					<div class="row pill">
						<p class="tag-pill" v-for="skill in passedSkills" :key="skill.id">
							{{ skill.id }}
						</p>
					</div>
				</div>
			</div>
			<div class="border-container" v-else>
				<h4 class="title"><md-icon>build</md-icon> Skills</h4>
				<div style="display: flex; flex-direction: column; align-items: center; padding: 1rem">
					<h3 class="not-found">No passed skills found on your profile</h3>
				</div>
			</div>

			<div class="border-container" v-if="profile && profile.preferredCompanies && profile.preferredCompanies.choices && profile.preferredCompanies.choices.length > 0">
				<h4 class="title"><md-icon>business</md-icon> Preferred Companies</h4>
				<div class="">
					<ul>
						<li v-for="(choice, index) in profile.preferredCompanies.choices" :key="index">{{ choice }}</li>
					</ul>
				</div>
			</div>

			<div class="border-container" v-else>
				<h4 class="title"><md-icon>business</md-icon> Preferred Companies</h4>
				<div class="">
					<div style="display: flex; flex-direction: column">
						<h3 class="not-found">You currently haven't selected your preferred companies</h3>
						<br />
						<md-button @click="editProfile" class="jb-standard" style="width: fit-content; margin: auto">Add to Profile</md-button>
					</div>
				</div>
			</div>

			<div class="border-container" v-if="profile && profile.preferredCompanies && profile.preferredCompanies.department && profile.preferredCompanies.department.length > 0">
				<h4 class="title"><md-icon>business</md-icon> Preferred Departments</h4>
				<div class="">
					<div class="row pill">
						<p class="tag-pill" v-for="(department, index) in profile.preferredCompanies.department" :key="index">{{ department.department }}</p>
					</div>
				</div>
			</div>

			<div class="border-container" v-else>
				<h4 class="title"><md-icon>business</md-icon> Preferred Departments</h4>
				<div class="">
					<div style="display: flex; flex-direction: column">
						<h3 class="not-found">You currently haven't selected your preferred departments</h3>
						<br />
						<md-button @click="editProfile" class="jb-standard" style="width: fit-content; margin: auto">Add to Profile</md-button>
					</div>
				</div>
			</div>

			<div class="border-container" v-if="!loading && profile && profile.cv">
				<h4 class="title"><md-icon>description</md-icon> Resumes</h4>
				<div class="">
					<div class="resume-list">
						<div class="resume-card-single">
							<div class="resume-header">
								<md-icon>description</md-icon>
								<span class="file-name">{{ profile.cv.fileName }}</span>
							</div>

							<div class="resume-actions">
								<md-button class="md-success" @click="downloadResume(profile.cv.url)"
									>Download <md-icon style="color: white !important">download</md-icon></md-button
								>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="background">
			<div v-if="loading" class="text-center lds-circle">
				<div><img src="@/assets/img/logo.png" /></div>
			</div>
		</div>
	</div>
</template>
<script>
import db from '@/firebase/init';
import firebase from 'firebase/compat/app';
import 'firebase/compat/storage';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
//
export default {
	name: 'client-profile',
	data() {
		return {
			profile: {},
			rating: 4.84,
			edit: false,
			loading: true,
		};
	},
	props: {
		cardUserImage: {
			type: String,
			default: '/img/default-avatar.png',
		},
	},
	methods: {
		editProfile() {
			this.loading = true;
			this.$router.push({ name: 'edit-student-profile', params: { id: this.$route.params.id } });
		},
		openLink(link) {
			window.open(link, '_blank');
		},
		downloadResume(url) {
			window.open(url, '_blank');
		},
	},
	async created() {
		try {
			const studentId = this.$route.params.id;
			const studentRef = db.collection('students').doc(studentId);
			const studentDoc = await studentRef.get();
			const studentData = studentDoc.data();
			this.profile = { ...studentData };

			const auth = firebase.auth().currentUser.uid === this.profile.userId;
			if (auth) this.edit = true;

			// Run all async fetches in parallel for speed
			const [qualificationsRef, skillsRef, experienceRef, userQuerySnapshot] = await Promise.all([
				studentRef.collection('qualifications').get(),
				studentRef.collection('skills').get(),
				studentRef.collection('experiences').get(),
				db.collection('users').where('userId', '==', this.profile.userId).limit(1).get(),
			]);

			// Populate profile fields
			this.profile.qualifications = qualificationsRef.docs.map(doc => doc.data());
			this.profile.skills = skillsRef.docs.map(doc => ({ id: doc.id, ...doc.data() }));
			this.profile.experience = experienceRef.docs.map(doc => doc.data());

			if (!userQuerySnapshot.empty) {
				const userData = userQuerySnapshot.docs[0].data();
				this.profile.name = userData.name;
				this.profile.surname = userData.surname;
			}
			this.loading = false;
		} catch (error) {
			console.error('Profile load error:', error);
		}
	},
	computed: {
		passedSkills() {
			if (!Array.isArray(this.profile.skills)) return [];
			return this.profile.skills.filter(skill => Array.isArray(skill.testResults) && skill.testResults.some(result => result.pass));
		},
		hasSocialMedia() {
			const p = this.profile;
			return p.github || p.linkedIn || p.facebook || p.twitter || p.instagram;
		},
		embeddedVideoUrl() {
			const url = this.profile.introductoryVideoUrl;
			if (!url) return null;
			if (url.includes('loom.com/share/')) {
				const parts = url.split('loom.com/share/');
				const videoId = parts[1]?.split('?')[0];
				if (videoId) return `https://www.loom.com/embed/${videoId}`;
			}

			if (url.includes('drive.google.com/file/d/')) {
				const parts = url.split('/d/');
				const fileId = parts[1]?.split('/')[0];
				if (fileId) return `https://drive.google.com/file/d/${fileId}/preview`;
			}

			if (url.includes('open?id=')) {
				const parts = url.split('open?id=');
				const fileId = parts[1]?.split('&')[0];
				if (fileId) return `https://drive.google.com/file/d/${fileId}/preview`;
			}

			try {
				const valid = new URL(url);
				return valid.href;
			} catch {
				console.warn('Invalid video URL:', url);
				return null;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.fix {
	z-index: 999 !important;
}
// utility
h1,
h2,
h3,
h4,
h5,
p {
	line-height: 16px;
}
.not-found {
	text-align: center;
}
.md-button:not(.md-just-icon):not(.md-btn-fab):not(.md-icon-button):not(.md-toolbar-toggle) .md-ripple {
	padding: 12px 15px !important;
}
.background {
	width: 100vw !important;
	height: 100vh !important;
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
}
.tag-pill {
	background-color: #ffedd5;
	color: #cb6c24;
	padding: 5px 10px 5px 10px;
	margin: 5px;
	border-radius: 50vw;

	&.qualification {
		font-size: 10px;
	}
}

.row {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: -1rem;

	&.pill {
		flex-wrap: wrap;
		justify-content: flex-start;
	}
}
.text {
	color: #4e5563;
	font-size: 14px;
	text-align: left;
}

.card-title {
	font-size: 14px;
	font-weight: bold;
}

.date {
	font-size: 14px;
}

.title {
	font-weight: bold;
	font-size: 20px;
}

.md-icon {
	color: darkorange !important;
	font-size: 20px !important;
}
.border-container {
	padding: 1rem;
	.border {
		width: 100%;
		border: 1px solid lightgrey;
		border-radius: 10px;
		padding: 10px;

		text-align: left;
		padding-bottom: 2rem;

		&.right {
			margin-top: 0;
		}
	}
}
.resume-list {
	display: flex;
	margin-top: 1rem;
	flex-wrap: wrap;

	.resume-card-single {
		width: 45%;
		height: fit-content;
		border: 1px solid lightgrey;
		border-radius: 10px;
		padding: 1rem;
		background-color: #fff;
		margin: 1rem;
		position: relative;

		@media (max-width: 692px) {
			width: 100%;
		}
	}

	.resume-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-weight: bold;
		margin-bottom: 0.5rem;
	}
}

.file-name {
	flex: 1;
	margin-left: 0.5rem;
	overflow-wrap: anywhere;
	font-size: 14px;
}

.primary-badge {
	background-color: #d1fae5;
	color: #065f46;
	font-size: 12px;
	padding: 2px 8px;
	border-radius: 10px;
	margin-left: 1rem;
}

.resume-actions {
	width: 100%;
	display: flex;
	justify-content: flex-end;
	.download-btn {
		cursor: pointer;
		width: fit-content;
		border: 1px solid lightgrey;
		padding: 10px;
		border-radius: 5px;
		&:hover {
			text-decoration: underline;
		}
	}
}

.profile-container {
	max-width: 1000px;
	margin: auto;
	background-color: white;
	padding: 2rem;
	.profile-section {
		border-bottom: 1px solid lightgrey;
		padding-bottom: 2rem;
		.profile-row {
			display: flex;
			padding: 1rem;

			.left {
				flex: 0.15;
			}

			.right {
				flex: 0.9;
			}
			h3 {
				font-weight: bold;
				font-size: 30px;
			}
			.img {
				width: 100px;
				height: 100px;
				border-radius: 50vw;
				margin-right: 1rem;
			}

			@media (max-width: 640px) {
				flex-direction: column;
				text-align: center;
			}
		}
	}

	.video-player {
		width: 100%;
		height: auto;
		position: relative;
		background-color: white;
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		iframe {
			width: 100%;
			height: 100%;
			border: none;
		}
	}

	.qualification-card {
		width: 100%;
		border: 1px solid lightgrey;
		border-radius: 10px;
		padding: 10px;
		padding-bottom: 2rem;
		margin-top: 1rem;
		text-align: left;
	}
}
</style>
